import type {DocNode} from '../types/docset';

export function findFirstContentNode(nodes: DocNode[]): DocNode | undefined {
  for (const node of nodes) {
    if (node.contentHref) {
      return node;
    }
    const child = findFirstContentNode(node.children);
    if (child) {
      return child;
    }
  }
  return undefined;
}

export function buildBreadcrumbs(node: DocNode | undefined): DocNode[] {
  if (!node) {
    return [];
  }
  const stack: DocNode[] = [];
  let current: DocNode | undefined = node;
  while (current) {
    stack.unshift(current);
    current = (current as any).parent ?? undefined;
  }
  return stack;
}

export function attachParentReferences(nodes: DocNode[], parent?: DocNode): void {
  for (const node of nodes) {
    (node as any).parent = parent ?? null;
    attachParentReferences(node.children, node);
  }
}

